import React, { Component } from 'react';
import './AddExtras.css';
import { connect } from 'react-redux';
import { Input, Button } from 'element-react';
import { saveExtras, getExtras } from '../../services/guests';

class AddExtras extends Component {
  constructor(props) {
    super(props);
    this.state = {
      extras: [
        { 
          name: null,
          qty: null,
          total: null
        }
      ],
      bookingId: this.props.location.state,
    };
  }

  async componentDidMount() {
    try {
      const { data: { extras }} = await getExtras(this.state.bookingId);
      if (extras) this.setState({ extras });
    } catch (err) {
      console.error(err);
    }
  }

  addGuest() {
    const guests = this.state.extras;
    guests.push({ 
      name: null,
      qty: null,
      total: null
    });
    this.setState({ guests });
  }

  deleteGuest(index) {
    const guests = this.state.extras;
    guests.splice(index, 1);
    this.setState({ guests });
  }

  valChange(field, text, index) {
    console.log(text);
    const guests = this.state.extras;
    guests[index][field] = text;
    this.setState({ guests });
  }

  async saveData() {
    await saveExtras(this.state.bookingId, this.state.extras);
    this.props.history.goBack();
  }

  render() {
    return (
      <div className="addExtrasWrapper">
        <div className="guestsList">
          {
            this.state.extras.length > 0 && this.state.extras.map((guest, index) => (
              <div key={index} className="guestDetail">
                <div className="headerGuestDetail"> 
                  <h4>Extra #{index + 1}</h4>
                  { index > 0 && <i className="el-icon-delete" onClick={() => this.deleteGuest(index)}></i> }
                </div>
                <Input type="text" placeholder="Articulo" value={guest.name} onChange={(text) => this.valChange('name', text, index)}/>
                <Input type="number" step="1" min="0" placeholder="Unidades" value={guest.qty} onChange={(text) => this.valChange('qty', parseInt(text), index)}/>
                <Input type="number" step="0.01" min="0" placeholder="Precio" value={guest.total} onChange={(text) => this.valChange('total', parseFloat(text), index)}/>
              </div>
            ))
          }
        </div>
        
        <Button onClick={() => this.addGuest()}>Añadir extra</Button>
        <Button onClick={() => this.saveData()}>Guardar datos</Button>
      </div>
    );
  }
}

const mapStateToProps = state => ({ rooms: state.rooms });

export default connect(mapStateToProps)(AddExtras);



// WEBPACK FOOTER //
// ./src/components/AddExtras/AddExtras.js